module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/015-el-salvador-c6e3251d460f3bb4c3ffffaba823bbe3.svg";